module.exports = __webpack_public_path__ + "static/hyperv_17.5bd5eec5.jpg";